module.exports = {
	"$schema": "http://json-schema.org/draft-04/schema#",
	"title": "Breakdown Array",
	"description": "A data array used for breakdown charts",
	"type": "array",
	"items": {
		"type": "object",
		"required": [
			"label",
			"percentage"
		],
		"properties": {
			"label": {
				"type": "string"
			},
			"percentage": {
				"type": "number"
			}
		}
	}
}